var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13728_133239",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13728_133239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6027 22.0661L22.1361 14.5328L20.2361 12.6328L14.6027 18.2661L11.7694 15.4328L9.8694 17.3328L14.6027 22.0661ZM16.0027 29.3328C14.3361 29.3328 12.775 29.0161 11.3194 28.3828C9.86385 27.7495 8.59718 26.8939 7.5194 25.8161C6.44162 24.7384 5.58607 23.4717 4.95273 22.0161C4.3194 20.5606 4.00273 18.9995 4.00273 17.3328C4.00273 15.6661 4.3194 14.105 4.95273 12.6495C5.58607 11.1939 6.44162 9.92726 7.5194 8.84948C8.59718 7.7717 9.86385 6.91615 11.3194 6.28281C12.775 5.64948 14.3361 5.33281 16.0027 5.33281C17.6694 5.33281 19.2305 5.64948 20.6861 6.28281C22.1416 6.91615 23.4083 7.7717 24.4861 8.84948C25.5638 9.92726 26.4194 11.1939 27.0527 12.6495C27.6861 14.105 28.0027 15.6661 28.0027 17.3328C28.0027 18.9995 27.6861 20.5606 27.0527 22.0161C26.4194 23.4717 25.5638 24.7384 24.4861 25.8161C23.4083 26.8939 22.1416 27.7495 20.6861 28.3828C19.2305 29.0161 17.6694 29.3328 16.0027 29.3328ZM7.4694 3.13281L9.33607 4.99948L3.6694 10.6661L1.80273 8.79948L7.4694 3.13281ZM24.5361 3.13281L30.2027 8.79948L28.3361 10.6661L22.6694 4.99948L24.5361 3.13281ZM16.0027 26.6661C18.6027 26.6661 20.8083 25.7606 22.6194 23.9495C24.4305 22.1384 25.3361 19.9328 25.3361 17.3328C25.3361 14.7328 24.4305 12.5273 22.6194 10.7161C20.8083 8.90503 18.6027 7.99948 16.0027 7.99948C13.4027 7.99948 11.1972 8.90503 9.38607 10.7161C7.57496 12.5273 6.6694 14.7328 6.6694 17.3328C6.6694 19.9328 7.57496 22.1384 9.38607 23.9495C11.1972 25.7606 13.4027 26.6661 16.0027 26.6661Z",
    fill: "#4CAF50"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock-icon.f7e89da8deb48fa2859d07a64bd2de26.svg";
export { ForwardRef as ReactComponent };